import React from 'react';
import IEditorStructure from '@start-set/wakadoo-editor-core/IEditorStructure';
import { ComponentOfferPresetting } from '../../../../../../shared/libs/EditorManipulators/editors/OfferPresetting';

interface PresettingProps {
    structure: IEditorStructure
}

const ComponentOfferPresettingContainer = (props: PresettingProps) => {
	const { structure } = props;

	return (
		<ComponentOfferPresetting structure={structure} />
	);
};

export default ComponentOfferPresettingContainer;
